import dayjs from '@core/lib/dayjs';

export const formatDate = (date) => {
  return dayjs(date).utc().format('MMMM DD, YYYY');
};
